import { render, staticRenderFns } from "./comCenterRc.vue?vue&type=template&id=1e2a1064&scoped=true&"
import script from "./comCenterRc.vue?vue&type=script&lang=js&"
export * from "./comCenterRc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2a1064",
  null
  
)

export default component.exports